const dialog    = require ('../../../../../components/dialog/dialog')

export function start( detail ){ 

	dialogBody[detail.id].start(detail) 
	
	detail.html =  dialogBody[detail.id]
	dialog.start(detail)
}


const dialogBody = {

	emailStatusInfo: {
		title: 'Email status information',
		des: '',
		bodyHtml: '',

		primary: {
			text: 'Close',
			class: 'button primary',
			dataDetail: `data-detail='{
				"click": [
					{"dest":"ripple"},
					{"dest":"dialog", "act":"hide"}
				]
			}'`,
		},

		secondary: {
			text: '',
			class: 'button secondary button-plain',
			dataDetail: '',
		},

		tertiary: {
			text: '',
			class: 'button secondary button-plain',
			dataDetail: '',
		},

		start: function () {
			this.bodyHtml = `
				<div class="des">
					<div class="font-body2 mb-16">
						These statuses show the current delivery state reported by the email service.
					</div>
					<div class="mb-16">
						<div class="font-body2-b">PENDING</div>
						<div class="font-body2 mt-8">The email was registered and is waiting for a delivery update.</div>
					</div>
					<div class="mb-16">
						<div class="font-body2-b">SENT</div>
						<div class="font-body2 mt-8">The recipient's email server accepted the message.</div>
					</div>
					<div class="mb-16">
						<div class="font-body2-b">SPAM</div>
						<div class="font-body2 mt-8">The recipient reported the message as unwanted email.</div>
					</div>
					<div class="mb-16">
						<div class="font-body2-b">BOUNCE</div>
						<div class="font-body2 mt-8">The message was rejected or could not be delivered to the recipient.</div>
					</div>
					<div>
						<div class="font-body2-b">BLOCKED</div>
						<div class="font-body2 mt-8">The email service stopped the message before delivery.</div>
					</div>
				</div>
			`
		},
	},

	saleSellingPrice: { 
		title:  '',
		des: '',
		bodyHtml:'',

		primary: {
			text:'',
			class:'button primary',
	        dataDetail:'',
		},

		secondary: {
			text:'Return',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},      

		start: function(detail){
			this.title     			  = 'Warning'
			this.des       		      = 'The selling price on the items below is lower than expected.<br> Do you still want to continue?\n' + detail.items
			this.primary.dataDetail   = `data-detail='{
	                       				 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
	                                     {"dest":"sale", "elem":"fullcont",  "id":"sale-fullcont", "act":"${detail.actDialog}", "entity":"sale"} ]}'`
			this.secondary.dataDetail = `data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`
			this.primary.text         = detail.mode
								
		}

	},

	SalecreditLimit: { 
		title:  '',
		des: '',
		bodyHtml:'',

		primary: {
			text:'Continue',
			class:'button primary',
	        dataDetail:'',
		},

		secondary: {
			text:'Return',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},      

		start: function(detail){
			this.title     			  = 'Warning'
			this.des       		      = "The invoice value exceeds the customer's credit"
			this.primary.dataDetail   = `data-detail='{
	                       				 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
	                                     {"dest":"sale", "elem":"fullcont",  "id":"sale-fullcont", "act":"addOneFromDialog", "entity":"sale"} ]}'`
			this.secondary.dataDetail = `data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`
								
		}

	},

	SalecreditLimitPrint: { 
		title:  '',
		des: '',
		bodyHtml:'',

		primary: {
			text:'Continue',
			class:'button primary',
	        dataDetail:'',
		},

		secondary: {
			text:'Return',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},      

		start: function(detail){
			this.title     			  = 'Warning'
			this.des       		      = "The invoice value exceeds the customer's credit"
			this.primary.dataDetail   = `data-detail='{
	                       				 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
	                                     {"dest":"sale", "elem":"fullcont",  "id":"sale-fullcont", "act":"addOnePrintFromDialog", "entity":"sale"} ]}'`
			this.secondary.dataDetail = `data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`
								
		}

	},
}
